export const createHelpHref = (anchor: string) => {
	const baseUri = "https://blog.rusetfs.com/posts/риски-и-драиверы-биржевых-фондов";
	if (!anchor)
		return baseUri;

	return `${baseUri}#${anchor}`;
}